import { Input as InputAntD, Timeline as TimeLineAntD } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 0 auto;

  .ant-page-header-back-button:focus,
  .ant-page-header-back-button:hover {
    color: ${({ theme }) => theme.primary};
  }

  .ant-steps-item-content {
    position: relative;
    bottom: 5px;
  }
`;

export const Blank = styled.div`
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.21);
  margin: 0 24px;
  padding: 32px;
  width: 960px;
`;

export const MessageBox = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;

export const Label = styled.div`
  color: #7f7f7f;
  margin-bottom: 2px;
  font-weight: 300;
  font-size: 15px;
`;

export const RadioOption = styled.span`
  font-weight: 300;
  font-size: 16px;
`;

export const Input = styled(InputAntD)`
  border-radius: 3px;
`;

export const Header = styled.div`
  font-weight: 300;
  padding-bottom: 8px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  border-bottom: 1px solid #ececec;
  margin-bottom: 24px;
`;

export const Indicator = styled.div`
  border-radius: 3px;
  border: 1px solid #ececec;
  padding: 24px;
  display: flex;
`;

export const IndicatorIcon = styled.div`
  margin-right: 24px;
  background-color: ${({ theme }) => theme.primary};
  border-radius: 3px;
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 52px;
`;

export const TimeLine: any = styled(TimeLineAntD)`
  margin-top: 8px;
`;

export const TimeLineTitle = styled.h3``;

export const TimeLineItem: any = styled(TimeLineAntD.Item)`
  width: 390px;
`;

export const TimeLineContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;
  margin-bottom: 8px;
`;

export const TimeLineContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
  justify-content: space-between;
  border-bottom-width: 1px;
  padding-bottom: 4px;
  margin-bottom: 8px;
  border-bottom: 1px solid #d9d9d9;
`;

export const TimeLineContentTitle = styled.p`
  margin: 0;
  padding: 0;
  font-family: 'Roboto', sans-serif;
  color: #9fa0a4;
  font-size: 14px;
`;

export const TimeLineContentRechargeValue = styled.p`
  margin: 0;
  padding: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
`;

export const TimeLineContentChargeBoxName = styled(TimeLineContentRechargeValue)`
  font-weight: bold;
  color: #7e7e7e;
`;

export const TimeLineContentUser = styled(TimeLineContentChargeBoxName)``;

export const TimeLineContentAddress = styled(TimeLineContentTitle)``;

export const BalanceDay = styled(TimeLineContentTitle)``;

export const SelectContainer = styled.div`
  margin-bottom: 16px;
  margin-right: 64px;
`;

export const ListArea = styled.div`
  display: flex;
  flex-direction: column;
`;
